// extracted by css-extract-rspack-plugin
export default {"headerContainer":"headerContainer-24IGu","underlined":"underlined-3UMwn","light":"light-150Sw","ghosted":"ghosted-HdGeg","secondary":"secondary-1JMtK"};